import axios from "axios"
import store from "../store/index.js"
import router from "../router/index.js"
let res = true;

const sendRequest = (requestType, endpoint, authenticated, data = null, successCallback = null, errorCallback = null, arrayBufferHeader = false) => {
  
  let username = store.getters.username 
  if (username == 'admin' && store.getters.getAPIURL.includes("64.225.105.22")){
    store.commit("LOGOUT");
    router.push({
      name: 'login'
    })
  }
  
  var headers = null;
  if(authenticated) {
    headers = {
      headers: {
        authorization : "Bearer " + store.getters.authToken 
      }
    };
    if(arrayBufferHeader) {
      headers['Content-Type'] = 'multipart/form-data'
    }
  }
  var requestObject = {
    get: axios.get,
    post: axios.post,
    delete: axios.delete,
    put: axios.put,
    patch: axios.patch
  };

  var apiUrl = store.getters.getAPIURL
  var url = apiUrl + endpoint;

  var request = null;
  if (data) {
    request = requestObject[requestType](url, data, headers);
  } else {
    request = requestObject[requestType](url, headers);
  }

  request
    .then(response => {
      if (successCallback) {
        successCallback(response);
      }
    })
    .catch(error => {
      if (errorCallback) {
        if(error.response && error.response.status == 401) {
          store.commit("LOGOUT");
          router.push({
            name: 'login'
          })
        }
        errorCallback(error);
      }
    })
  };
  export { sendRequest };
